import type { ApiSchema } from "@/modules/api";
import type { AssistantSkillObservable } from "@/store/assistant";

export type AgentSkill = AssistantSkillObservable;
export type CreateAgentSkill = {
  name: string;
  when_to_use: string;
  instructions: string;
};
export type AcceptSharedAgentSkill =
  ApiSchema["CoreApi__AcceptSharedMemAgentSkillResponseSchema"];
export type AgentSkillShare = ApiSchema["CoreApi__MemAgentSkillShareResponseSchema"];
export type SharedAgentSkill = ApiSchema["CoreApi__SharedMemAgentSkillResponseSchema"];

/** Mirrors the backend ASSISTANT_SKILL_*_MAX_LENGTH contract limits. */
export const AGENT_SKILL_FIELD_LIMITS = {
  name: 80,
  whenToUse: 500,
  instructions: 4000,
} as const;
